<template lang="pug">
.report
  setting-title(
      title="访客细查",
      description="访客细查报告帮助您了解网站每个访客每一次的访问信息及行为路径，对单个访客进行深入分析")

  .report-content(v-show="calcLoading")
    .mask-panel
      img(src="https://p1.ssl.qhimg.com/t0173f568f185dc492d.gif")
  timeSpan(@change="onTimespanChange")
  .toolbar-row
    v-select(
      v-model="clusterid",
      :options="crowdList",
      @input="clusterChange()"
      )
    DownloadBtn(
      :reportApi="reportApi",
      :params="query",
      pagetitle="访客细查",
      subtitle="",
      v-if="total > 0",
      style="float: right;")
  .zone
    BaseTable(
      classname="data-table bluethead opt-table",
      :columns="columns",
      :list="tableDataList",
      :sum="{}",
      :sortKey="order",
      :sortOrder="isasc"
      )
      template(slot="opt-td" scope="props")
        a(:href="getDetailUrl(props.item)",
          target="_blank"
        ) 
          i.fa.fa-eye.fa-lg(title="查看", :style="{marginRight: '8px'}")
          |查看详情
      v-select(
        slot="tnum-th",
        v-model="transelected",
        :options="transList",
        @input="transChange()"
        )

    v-pagination(
      :total="total",
      :pn="pn",
      :ps="ps",
      v-if="total > ps",
      @updatepage="updatePage")
    v-modal(:visible="!!isMv",
        ref="mvModal"
        @closemodal="gotoSetting",
        title=""
      )
      .modal-bd
        p.text-content 使用该功能需要在网站部署360分析代码
        p.mv-container
          button.btn.btn-primary.btn-small.btn-mgr(@click="gotoSetting()") 去设置


</template>
<script>
/* global _ */
import Store from '../../store/store.js'
import Mixin from '../mixin.js'
import CrowdMixin from '../crowdmixin'
import BaseTable from '../../component/base-table.vue'
export default {
  components: {
    BaseTable
  },
  mixins: [Mixin, CrowdMixin],
  store: Store,
  data () {
    return {
      module: 'guid',
      isMv: '',
      calcLoading: false,
      cacheVersion: '',
      timer: '',
      transelected: 'null',
      transList: [
        {
          label: '全部转化',
          value: 'null'
        }
      ],
      reportApi: '/api/visit/list',
      isasc: 0,
      order: 'guid',
      total: 0,
      pn: 1,
      ps: 10,
      tableDataList: [],
      clusterid: 0,
      crowdList: [
        {
          value: 0,
          label: '全部人群'
        }
      ],
      columns: [
        {
          title: '访客ID',
          key: 'guid',
          render (index, value, item) {
            return `<span title="${value}">${value.slice(0,18) + '...'}</span>`
          },
          sorter: this.sorter
        }, {
          title: '访问次数',
          key: 'vnum',
          class: 'right',
          render: this.columnRender,
          sorter: this.sorter
        }, {
          title: '平均访问时长',
          key: 'atime',
          class: 'right',
          sorter: this.sorter,
          render: this.atimeRender
        }, {
          title: '平均访问页数',
          key: 'anum',
          class: 'right',
          sorter: this.sorter,
          render: this.columnRender
        }, {
          title: '跳出率',
          class: 'right',
          sorter: this.sorter,
          key: 'jrate',
          render: this.percentRender
        }, {
          title: '自定义转化次数',
          class: 'right visiable-th',
          sorter: this.sorter,
          render: this.columnRender,
          width: 220,
          key: 'tnum'
        },
        {
          title: '订单量',
          class: 'right',
          sorter: this.sorter,
          render: this.columnRender,
          key: 'ordernum'
        }, {
          title: '注册量',
          class: 'right',
          sorter: this.sorter,
          render: this.columnRender,
          key: 'reg'
        },
        {
          title: '操作',
          key: 'opt'
        }
      ]
    }
  },
  created () {
    this.getTransList()
    this.clusterid = this.$store.state.currentClusterId || 0
    this.getCrowd()
    this.checkMvSite()
  },
  computed: {
    end () {
      return this.$store.state.end
    },
    start () {
      return this.$store.state.start
    },
    domainId () {
      return this.$store.state.domainId
    },
    uiError () {
      return this.$store.state.uiError
    },
    query () {
      this.clusterid = this.clusterid === '' ? this.$store.state.currentClusterId : this.clusterid
      let query = {
        domainId: this.$store.state.domainId,
        clusterid: this.clusterid,
        start: this.$store.state.start,
        end: this.$store.state.end,
        order: this.order,
        isasc: this.isasc,
        ps: this.ps,
        pg: this.pn,
        cache_version: this.cacheVersion
      }
      if (this.transelected !== 'null') {
        query = _.assign({
          tids: this.transelected
        }, query)
      }
      return query
    }
  },
  watch: {
    domainId () {
      this.clusterid = 0
      this.getTransList()
      this.checkMvSite()
      this.getCrowd()
    },
    uiError () {
      this.$Modal.warn(this.uiError.errMsg)
    }
  },
  methods: {
    clusterChange () {
      if (this.isMv === '' || this.clusterid === '') return
      if (this.clusterid) {
        this.heatbeat()
      } else {
        this.updatePage(1)
      }
    },
    transChange () {
      if (this.clusterid) {
        this.heatbeat()
      } else {
        this.updatePage(1)
      }
    },
    backCrowd () {
      this.clusterid = 0
      this.getCrowdList()
    },
    transTypeName (key) {
      const transType = ['全部转化', '页面转化', '事件转化', '时长转化', '页数转化']
      return transType[key]
    },
    getTransList () {
      const translistPromise = this.$http.get('/api/trans/list', {
        params: {
          ps: 100,
          pg: 1,
          cycle: 'hour',
          domainId: this.domainId,
          timespan: new Date().getTime()
        }
      })
      this.$store.dispatch('VUE_HTTP', [translistPromise])
        .then((res) => {
          if (res) {
            const transList = _.groupBy(_.get(res, 'list'), 'type')
            const newTransList = [
              {
                label: '全部转化',
                value: 'null'
              }
            ]
            // 根据v-select所需options的格式进行修改
            _.forIn(transList, (value, key) => {
              newTransList.push({
                label: this.transTypeName(key),
                options: value.map(item => {
                  return {
                    value: item.id,
                    label: '' + item.name
                  }
                })
              })
            })
            this.transList = newTransList
          }
        })
    },
    sorter (key, order) {
      this.order = key
      this.isasc = order
      this.getCrowdList()
    },
    onTimespanChange ({start, end}) {
      if (this.isMv !== '') {
        this.heatbeat()
      }
    },
    getCrowd () {
      const crowdPromise = this.$http.get('/api/crowd/list', {
        params: {
          domainId: this.$store.state.domainId,
          ps: 100,
          pg: 1
        }
      })
      return this.$store.dispatch('VUE_HTTP', [crowdPromise])
        .then(res => {
          const crowdList = res.list.map(item => {
            item.value = item.id
            item.label = '' + item.name
            return item
          })
          this.crowdList = _.concat([
            {
              value: 0,
              label: '全部人群'
            }
          ], crowdList)
          this.$nextTick(() => {
            this.clusterid = this.clusterid === '' ? this.$store.state.currentClusterId : 0
          })
        })
    },
    checkMvSite () {
      this.isMvSite()
        .then(res => {
          if (!res.errno) {
            this.isMv = false
            if (!res.isMv) {
              if (this.clusterid && this.cacheVersion) {
                this.updatePage(1)
              } else {
                this.heatbeat()
              }
            } else {
              this.calcLoading = false
              this.isMv = true
            }
          } else {
            this.calcLoading = false
          }
        })
    },
    getCrowdList () {
      this.$store.dispatch('SET_TABLE_LOADING', true)
      const crowdListPromise = this.$http.get(this.reportApi, {
        params: this.query
      })
      this.$store.dispatch('VUE_HTTP', [crowdListPromise])
        .then(res => {
          if (!res.errno) {
            this.total = res.total
            this.tableDataList = res.list
          } else {
            this.total = 0
            this.tableDataList = []
          }
          this.calcLoading = false
          this.$store.dispatch('SET_TABLE_LOADING', false)
        })
    },
    updatePage (pn) {
      this.pn = pn
      this.getCrowdList()
    },
    getDetailUrl (item) {
      return `/setting/personDetail?domainId=${this.$store.state.domainId}&guid=${item.guid}&start=${this.start}&end=${this.end}`
    }
  },
  destroyed () {
    this.$store.dispatch('SET_CLUSTER_ID', 0)
    clearInterval(this.timer)
  }
}
</script>
<style scoped>
.toolbar-row {
  margin-left: -5px;
}
.modal-bd {
  width: 500px;
  p {
    text-align: center;
    margin: 20px;
  }
}
p.text-content {
    text-align: center;
    font-size: 14px;
    margin: 20px;
}
.mask-panel {
  position: absolute;
  top: 100px;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 8;
  background: rgba(252, 252, 253, .8);
  img {
    position: absolute;
    top: 200px;
    left: 50%;
    transform: translate(-50%,-50%);
  }
}
.v-select {
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// visitInfo.vue?52387a12